import { ROUTES } from '../../../shared/config/routes';
import { dateRangeToSearchString } from '../hooks/useDateRangeParams';
import type { DateRangeOption } from '../types/account-stats';

/** Отчёты, которые открываются со страницы аккаунта уже с ним и периодом. */
export const ACCOUNT_REPORTS = [
  { id: 'xlsx', label: 'Таблица с метриками', description: 'Excel: публикации периода строками' },
  { id: 'docx', label: 'Сводка для отчётности', description: 'Google Docs или Word' },
  { id: 'links', label: 'Ссылки и темы', description: 'Два документа: со скринами и без' },
  { id: 'top', label: 'Топ видео', description: 'Самые просматриваемые ролики с комментариями' },
] as const;

const query = (accountId: string, option: DateRangeOption) =>
  `account=${encodeURIComponent(accountId)}&${dateRangeToSearchString(option)}`;

/** «Выгрузки» с выбранным отчётом, аккаунтом и периодом. */
export function accountReportUrl(report: string, accountId: string, option: DateRangeOption): string {
  return `${ROUTES.STATS_REPORT}?report=${encodeURIComponent(report)}&${query(accountId, option)}`;
}

/** «История сборов» этого аккаунта за тот же период. */
export function accountHistoryUrl(accountId: string, option: DateRangeOption): string {
  return `/stats/history?${query(accountId, option)}`;
}

/**
 * «Назад» — прямо на вкладку «По аккаунтам» с тем же адресом: прежний путь
 * через /analytics/general терял параметры на редиректе.
 */
export function backToAccountsUrl(search: string): string {
  const params = new URLSearchParams(search);
  const q = params.toString();
  return q ? `${ROUTES.STATS_ACCOUNTS}?${q}` : ROUTES.STATS_ACCOUNTS;
}
